<template>
  <div class="">
    <!-- <br />Tree: {{ tree }} -->
    <!-- {{ imageForTree }} -->
    <!-- {{ meta.minLevel }}
    {{ meta.maxLevel }} -->
    <div v-for="(val, theKey) in tree" :key="theKey">
      <div class="d-flex flex-row align-center">
        <!--    pu: {{ isPenultimateCode(theKey) }} abridged: {{ abridged
        }}level:
        {{ codes[theKey].level }} -->
        <!-- {{ isLastLevel(theKey) }} -->

        <div
          v-if="!isMobile && showImages && isLastLevel(theKey)"
          style="width: 65px; flex-shrink: 0"
        >
          <v-img
            v-if="codes[theKey].image"
            :src="imgPath + codes[theKey].image"
            contain
            class="px-1 my-1"
            max-height="38px"
          />
        </div>
        <div class="d-flex flex-row">
          <div
            v-if="isPenultimateCode(theKey)"
            class="leftLine pl-1 pl-sm-4 penultimateCode"
          >
            <icd-item
              :theKey="theKey"
              :codes="codes"
              :meta="meta"
              :makeLink="abridged"
              :sevenChar="sevenChar"
            ></icd-item>

            <icd-widget
              :codes="codesInList(val)"
              :parentObj="codes[theKey]"
              :sevenChar="sevenChar || codes[theKey].sevenChar"
              :expandAll="expandAll"
            ></icd-widget>
          </div>
          <div v-else class="leftLine pl-1 pl-sm-4 nonPenultimateCode">
            <icd-item
              :theKey="theKey"
              :codes="codes"
              :meta="meta"
              :makeLink="abridged"
              :sevenChar="sevenChar"
            ></icd-item>

            <icd-tree-element
              :sevenChar="sevenChar"
              :codes="codes"
              :meta="meta"
              :tree="val"
              :expandAll="expandAll"
              :abridged="abridged"
              v-if="Object.keys(val).length != 0"
            ></icd-tree-element>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IcdTreeElement",
  components: {
    IcdTreeElement: () => import("./IcdTreeElement"),
    IcdItem: () => import("./IcdItem"),
    IcdWidget: () => import("./IcdWidget"),
  },
  props: {
    meta: null,
    codes: null,
    tree: null,
    sevenChar: null,
    expandAll: null,
  },
  data: function () {
    return {
      imgPath: "https://www.eyedock.com/images",
      showImages: false,
      // showSpecifics: false,
      //   codeFromChild: null,
    };
  },
  methods: {
    codesInList(list) {
      let codes = {};
      let listKeys = Object.keys(list);
      for (const code of listKeys) {
        codes[code] = this.codes[code];
      }
      return codes;
    },

    isPenultimateCode(key) {
      let cs = this.codes;
      if (!cs[key]?.penultimate) return false;
      return cs[key].penultimate == 1;
    },
    isLastLevel(key) {
      let maxLevel = this.meta?.maxLevel;
      let level = parseInt(this.codes[key]?.level);
      // console.log("level: " + level + " maxLevel: " + maxLevel);
      return level == maxLevel;
    },
    checkForImages() {
      let rtn = false;
      this.treeKeys.forEach((code) => {
        if (this.codes[code]?.image) rtn = true;
      });
      this.showImages = rtn;
      // this.showImages = this.meta?.images && this.meta.images.length > 0;
    },
  },
  computed: {
    isMobile: function () {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    abridged: function () {
      return this.meta?.abridged;
    },
    treeKeys: function () {
      return Object.keys(this.tree);
    },

    // showImages: function () {
    //   return this.meta?.images;
    // },
    // imagesForTree: function () {
    //   let images = this.meta?.images;
    //   let imageArr = null;
    //   if (!images) return null;
    //   this.treeKeys.forEach((key) => {
    //     if (images[key]) image = images[key];
    //   });
    //   return image;
    // },
  },
  watch: {
    tree: function () {
      this.checkForImages();
    },
  },
  mounted() {
    this.checkForImages();
  },
};
</script>

<style scoped>
/* .bordered {
  padding: 4px 2px 4px 8px;
  background-color: rgba(255, 140, 0, 0.044);
} */
.leftLine {
  border-left: 1px dotted rgb(244, 200, 162);
  padding-top: 4px;
  padding-right: 2px;
  padding-bottom: 4px;
  /* background-color: rgba(255, 140, 0, 0.044); */
}
</style>
